import PhaseOScope from "./components/PhaseOScope";
import { GlobalStyle } from "./GlobalStyle";
import "./App.css";

function App() {
  return (
    <>
      <GlobalStyle />
      <PhaseOScope />
    </>
  );
}

export default App;
